/* eslint-disable eqeqeq */
import config from '__api/config';
import { checkNewUser } from '__api/dsbc/inv/checkNewUser';
import { InvResultDataVO } from '__api/dsbc/inv/getInvList';
import { InvRewardDataVO } from '__api/dsbc/inv/getInvRewardList';
import { getInvUser } from '__api/dsbc/inv/getInvUser';
import { getMonthRwdList } from '__api/dsbc/inv/getMonthRwdList';
import { RankInvDataVO } from '__api/dsbc/inv/invUserRank';
import { setViewed } from '__api/dsbc/inv/setViewed';
import { DrawListVo, invDraw } from '__api/dsbc/safe/invDraw';
import {
  RemoteImageMetadata,
  RemoteImageRequestStatus,
  createRemoteImageRequest,
} from '__api/image/createRemoteImageRequest';
import { getDataFromPoint } from '__api/other/getDataFromPoint';
import { getPZFromPoint } from '__api/other/getPZFromPoint';
import { point } from '__api/other/point';
import { ImageData, queryImageByCode, queryImageListByGroupId } from '__api/pzpt';
import { addNewUserDraw } from '__api/zqhd/AddnewUserDraw';
import { finishTask } from '__api/zqhd/FinishTask';
import { getAcConfig } from '__api/zqhd/GetAcConfig';
import { getAlterPop } from '__api/zqhd/GetAlterPop';
import { getDrawConfigInfo, GetDrawConfigInfoRes } from '__api/zqhd/GetDrawConfigInfo';
import { getkickOffTime } from '__api/zqhd/GetkickOffTime';
import { CompWelfareTaskRes, queryTaskList } from '__api/zqhd/QueryTaskList';
import { DrawInfo, SycnDrawInfo } from '__api/zqhd/SycnDrawInfo';
import { Notice } from '__components/Notice';
import { ShareButton } from '__components/ShareButton';
import { AdConfig, shareAdConfig, scrollData } from '__constants/AdConfig';
import { ApiHasErrorMessage } from '__constants/http';
import { AppShare, setWxShareInfo } from '__utils/appShare';
import { openUrl } from '__utils/openUrl';
import dayjs from 'dayjs';
import { RootSiblingContainer } from 'emrn-design';
import { Arrow } from 'emrn-design/Arrow';
import { Dialog } from 'emrn-design/Dialog';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Loading } from 'emrn-design/Loading';
import { Spacer } from 'emrn-design/Spacer';
import { SwiperView } from 'emrn-design/SwiperView';
import { PaginationDot } from 'emrn-design/SwiperView/PaginationDot';
import { Toast } from 'emrn-design/Toast';
import { isIPad } from 'emrn-design/isIPad';
import { rpx } from 'emrn-design/rpx';
import { LocalStorage } from 'emrn-essential/lib/hybrid';
import { Container } from 'emrn-hybrid/Container';
import { Logger } from 'emrn-hybrid/Logger';
import { Passport } from 'emrn-hybrid/Passport';
import { closeContainer } from 'emrn-hybrid/closeContainer';
import { invoke } from 'emrn-hybrid/invoke';
import { isAppVersionGE } from 'emrn-hybrid/isAppVersionGE';
import { trackEvent } from 'emrn-hybrid/trackEvent';
import { TrackPage } from 'emrn-misc/TrackPage';
import { EmPageProps } from 'emrn-navigation';
import { AnimatedHeader } from 'emrn-navigation/AnimatedHeader';
import { Header } from 'emrn-navigation/Header';
import { PageVisibilityWatch } from 'emrn-navigation/PageVisibilityWatch';
import React, { Component } from 'react';
import {
  StyleSheet,
  Animated,
  NativeSyntheticEvent,
  NativeScrollEvent,
  Text,
  View,
  Platform,
  Image,
  ImageBackground,
  Easing,
  NativeModules,
  ScrollView,
} from 'react-native';
import { ActivityEndPop } from '../dialogPops/activityEndPop';
import { CalendarPop } from '../dialogPops/calendarPop';
import { CountLimitPop } from '../dialogPops/countLimitPop';
import { DrawCashPop } from '../dialogPops/drawCashPop';
import { InviteRecordPop } from '../dialogPops/inviteRecordPop';
import { LeaveRetainPop } from '../dialogPops/leaveRetainPop';
import { MonthRewardPop } from '../dialogPops/monthAwardPop';
import { NoAwardPop } from '../dialogPops/noAwardPop';
import { NoRewardPop } from '../dialogPops/noRewardPop';
import { OpenRedBagPop } from '../dialogPops/openRedBagPop';
import { RewardRecordPop } from '../dialogPops/rewardRecordPop';
import { RulePop } from '../dialogPops/rulePop';
import { ShareTipPop } from '../dialogPops/shareTipPop';
import { SurpriseTaskPop } from '../dialogPops/surpriseTaskPop';
import { TenDrawCashPop } from '../dialogPops/tenDrawCashPop';
import { TipsPop } from '../dialogPops/tipsPop';
import { ScrollVertical } from './scrollVertical';

const { height: HeaderHeight } = Header.getSize(false);
const initDeg = 3 * 360;

/**
 * 状态
 */
interface InviteState {
  /**
   * y轴滑动位移
   */
  scrollY: Animated.Value;
  /**
   * 转盘旋转变量
   */
  rotationValue: Animated.Value;
  /**
   * 十连抽开关
   */
  switchTen: boolean;
  /**
   * 榜单状态 1-本月榜单 2-上月榜单 3-总榜单
   */
  rankType: number;
  /**
   * 底部高度
   */
  bottomHeight: number;
  /**
   * 剩余抽奖机会
   */
  drawCashTimes: string;
  /**
   * 奖品配置数据
   */
  rewardData: any[] | undefined;
  /**
   * 用户邀请记录数据
   */
  inviteRecordData: InvResultDataVO[] | undefined;
  /**
   * 用户奖励记录数据
   */
  rewardRecordData: InvRewardDataVO[] | undefined;
  /**
   * 是否展示奖励记录按钮
   */
  isShowrewardRecordBtn: boolean;
  /**
   * 邀请好友总数
   */
  inviteAccount: string;
  /**
   * 榜单数据
   */
  invRankData: RankInvDataVO[] | undefined;
  /**
   * 榜单下方个人邀请数据
   */
  selfInfo: RankInvDataVO;
  /**
   * 是否展示上月榜
   */
  isShowLastMonth: boolean;
  /**
   * 指针旋转度数
   */
  dgeValue: number;
  /**
   * 转盘旋转变量
   */
  rotateInterpolate: any;
  /**
   * 配置图片宽高比集合
   */
  w_hData: (RemoteImageMetadata | undefined)[];

  /**
   * 手指缩放倍数
   * */
  scaleValue: Animated.ValueXY;
  /**
   * 惊喜任务列表
   */
  surpriseTaskList: CompWelfareTaskRes[];
  /**
   * 日常任务列表
   */
  dailyTaskList: CompWelfareTaskRes[];
  /**
   * 查看全部任务
   */
  isWatchAllTask: boolean;
  /*活动规则*/
  ruleText: string;
  /**
   * 广告位
   * */
  noticeAdConfig: Array<ImageData>;
  /**
   * 抽奖配置信息
   * */
  drawConfigInfo: GetDrawConfigInfoRes;
  /**
   * 次数信息
   * */
  drawList: Array<DrawListVo>;
  /* 是否弹窗 */
  isRetainPop: boolean;
  /**
   * 按钮缩放
   * */
  scaleBtn: Animated.Value;
  /**
   * 按钮缩放 十连抽
   * */
  scaleBtnTen: Animated.Value;
  /**
   * 抽奖激活的序号
   * */
  activeIndex: number | null;
  /**
   * 邀请用户等级
   * 1 - V1
   * 2 - V2
   * 3 - V3
   */
  level: string;
  /**
   * 晋级方式
   * 0 lv3，展示我知道了
   * 1 lv1，跳转中金所大赛
   * 2 lv2 跳转实名认证
   * 为0时，按钮展示”我知道了“
   */
  promWay: string;
  /**是否是惊喜任务的分享*/
  isTaskShare: boolean;
  /**
   * 跑马灯信息
   * */
  notice: string;
  /**
   * 开赛时间
   * */
  kickOffTime: string;
  /**
   * 是否开赛
   * */
  showFlag: boolean;
}

/**
 * 邀新页面
 */
export class Invite extends Component<EmPageProps, InviteState> {
  static displayName = 'Invite';
  private dialog = React.createRef<Dialog>();
  private toast = React.createRef<Toast>();
  private loading = React.createRef<Loading>();
  private noRewardPop = React.createRef<NoRewardPop>();
  private rulePop = React.createRef<RulePop>();
  private calendarPop = React.createRef<CalendarPop>();
  private monthRewardPop = React.createRef<MonthRewardPop>();
  private drawCashPop = React.createRef<DrawCashPop>();
  private inviteRecordPop = React.createRef<InviteRecordPop>();
  private rewardRecordPop = React.createRef<RewardRecordPop>();
  private openRedBagPop = React.createRef<OpenRedBagPop>();
  private tenDrawCashPop = React.createRef<TenDrawCashPop>();
  private surpriseTaskPop = React.createRef<SurpriseTaskPop>();
  private activityEndPop = React.createRef<ActivityEndPop>();
  private leaveRetainPop = React.createRef<LeaveRetainPop>();
  private noAwardPop = React.createRef<NoAwardPop>();
  private shareTipPop = React.createRef<ShareTipPop>();
  private countLimitPop = React.createRef<CountLimitPop>();
  private tipsPop = React.createRef<TipsPop>();
  //配置活动时间列表
  private isEndOfActivity: boolean = false;
  private rotationEnabled: boolean = true;
  private resetNum: number = 0;
  private accountDrawTime = 0;
  private tenChooseName: object[] = [];
  private slideAnimation: Animated.CompositeAnimation | undefined;
  private slideAnimationV1: Animated.CompositeAnimation | undefined;
  private handAnimation: Animated.CompositeAnimation | undefined;
  private handScaleAnimation: Animated.CompositeAnimation | undefined;
  private handScaleTenAnimation: Animated.CompositeAnimation | undefined;
  private scrollToPosition: any = null;
  private jumpPosition: number = 0;
  private timer: any = null;
  constructor(props: EmPageProps) {
    super(props);
    this.state = {
      scaleBtn: new Animated.Value(1),
      scaleBtnTen: new Animated.Value(1),
      scrollY: new Animated.Value(0),
      rotationValue: new Animated.Value(0),
      switchTen: false,
      rankType: 1,
      bottomHeight: rpx(600),
      drawCashTimes: '0',
      rewardData: undefined,
      inviteRecordData: undefined,
      rewardRecordData: undefined,
      isShowrewardRecordBtn: false,
      inviteAccount: '',
      invRankData: undefined,
      selfInfo: {},
      isShowLastMonth: false,
      dgeValue: 0,
      rotateInterpolate: '0deg',
      w_hData: [],
      scaleValue: new Animated.ValueXY({ x: 0, y: 0 }),
      surpriseTaskList: [],
      dailyTaskList: [],
      isWatchAllTask: false,
      ruleText: '',
      noticeAdConfig: [],
      drawConfigInfo: {
        newUserTaskId: '', // 新用户抽奖任务id
        normalTaskId: '', // 普通任务抽奖任务id
        surpriseTaskId: '', //惊喜任务抽奖任务id
      },
      drawList: [],
      isRetainPop: true,
      activeIndex: null,
      promWay: '',
      level: '',
      isTaskShare: false,
      notice: '',
      kickOffTime: '',
      showFlag: false,
    };
  }
  async componentDidMount() {
    let { hasLogin: passportHasLogin } = await Passport.getUserInfo();
    if (!passportHasLogin) {
      const { info, hasLogin } = await Passport.requestLogin();
      if (!info || !hasLogin) {
        closeContainer();
        // if (NativeModules.AppCommonModule && NativeModules.AppCommonModule.backToNativeView) {
        //   NativeModules.AppCommonModule.backToNativeView();
        // } else {
        // }
      }
    }
    let loading = this.loading.current?.show();

    await this._getRewardPoolConfig();
    await this.init();
    this._getRuleText();
    // this._getNoticeAdConfig();
    this._handScaleAnimation();
    loading?.destroy();
    setTimeout(async () => {
      let toScroll = this.props.navigation.getParam('toScroll');
      if (toScroll) {
        this.toScroll();
      }
      // 新用户奖池次数为0 并且checkUser接口返回true 弹出惊喜新人弹窗 点击领取增加抽奖机会
      !this.state.drawList[0]?.drawCnt && (await this._checkNewUser()) && this.surpriseTaskPop.current?.show();
    }, 1000);
    if (Platform.OS === 'web') {
      this.setShareInfo(shareAdConfig.common.code);
    }
    if (!this.isEndOfActivity) {
      this.timer && clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        this._getDataFromPoint();
      }, 30000);
    }
  }
  componentWillUnmount() {
    this.stopAnimation();
    this.stopHandAnimation();
    this.timer && clearInterval(this.timer);
    this.timer = null;
  }
  init = async () => {
    this._queryTaskList();
    this._getAcConfig();
    this._getPZFromPoint(this.state.drawConfigInfo?.surpriseTaskId);
    this._getDataFromPoint();
    this._getInvUserInfo();
    this._getkickOffTime();
    //月榜奖励
    if (!this.isEndOfActivity) {
      await this._getMonthRwdList();
    }
  };
  onAppear = async () => {
    if (this.props.navigation.isFocused()) {
      await this.init();
    }
  };
  /** 查询邀请人信息 */
  _getInvUserInfo = async () => {
    try {
      if (Platform.OS === 'web') {
        return;
      }
      const res = await getInvUser({
        invId: config.invId,
      });
      if (res && res.IsSuccess) {
        this.setState({
          promWay: res.Data?.promWay,
          level: res.Data?.level,
        });
        if (res.Data?.invLimit === '1') {
          this.countLimitPop.current?.show();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  /**查询跑马灯信息*/
  _getAcConfig = async () => {
    try {
      const res = await getAcConfig({
        acNo: 'CFFEX_CUP_WELFARE',
        paramCode: ['notice'],
      });
      this.setState({
        notice: res?.data?.notice || '',
      });
    } catch (e) {
      console.log(e);
    }
  };
  _getkickOffTime = async () => {
    try {
      // TODO 60117测试  30031生产
      const { Data } = await getkickOffTime({
        compId: '30031',
        inShow: false,
      });
      const resList = Data.raceList.find(item => String(item.period) === '1');
      this.setState({
        kickOffTime: resList?.raceStartTime || '2025-09-22 09:30:00',
        showFlag: resList?.showFlag || false,
      });
    } catch (e) {
      console.log(e);
    }
  };
  /* 同步抽奖结果 */
  _syncDrawInfo = async (drawList: DrawInfo[]) => {
    try {
      await SycnDrawInfo({
        drawList,
      });
    } catch (e) {}
  };
  /*校验用户是否是新用户*/
  _checkNewUser = async () => {
    try {
      if (Platform.OS === 'web') {
        return;
      }
      const { hasLogin } = await Passport.getUserInfo();
      if (!hasLogin) {
        return;
      }
      const res = await checkNewUser({
        invId: config.invId,
      });
      if (res && res.IsSuccess) {
        return res.Data;
      } else {
        return false;
      }
    } catch (e) {
      return;
    }
  };
  /* 获取抽奖信息配置、任务id*/
  _getRewardPoolConfig = async () => {
    try {
      const { data } = await getDrawConfigInfo();
      this.setState({
        drawConfigInfo: {
          newUserTaskId: data?.newUserTaskId || '', // 新用户抽奖任务id
          normalTaskId: data?.normalTaskId || '', // 普通任务抽奖任务id
          surpriseTaskId: data?.surpriseTaskId || '', // 惊喜任务抽奖任务id
        },
      });
    } catch (e) {
      return;
    }
  };
  setShareInfo = async (groupCode: string) => {
    await queryImageByCode({ groupCode: 'g_cffe_welfare_officer' })
      .then(res => {
        if (res && res.code == 0) {
          if (res.data && res.data.length > 0) {
            let adInfo = res.data?.find(item => item.materialCode === groupCode);
            setWxShareInfo({
              title: adInfo?.title || '',
              desc: adInfo?.subTitle || '',
              imgUrl: adInfo?.imgUrl || '',
            });
          }
        } else {
          //Dialog(res.message || ApiHasErrorMessage);
        }
      })
      .catch(() => {});
  };
  /*获取底部广告位*/
  _getNoticeAdConfig = async () => {
    const res = await queryImageByCode({ groupCode: AdConfig.Banner.code });
    console.log(res, 'adasdsadasd');
    if (res && res.code == 0 && res.data) {
      this.setState({
        noticeAdConfig: res.data,
      });
    } else {
      return;
    }
  };
  /**
   * 增加抽獎机会
   * */
  _addAwardCount = async () => {
    await addNewUserDraw();
  };
  /**
   * 获取月榜奖励
   */
  _getMonthRwdList = async () => {
    try {
      if (Platform.OS === 'web') {
        return;
      }
      const { hasLogin } = await Passport.getUserInfo();
      if (!hasLogin) {
        return;
      }
      //id: 赛项ID
      let res = await getMonthRwdList({ invId: config.invId });
      if (res && res.IsSuccess) {
        if (res.Data && res.Data.length > 0) {
          res.Data.forEach(item => {
            if (item.getNote == '1') {
              this.monthRewardPop.current?.show(item.rewardValue || '', item.rewardIndex || '');
              return;
            }
          });
        }
      }
    } catch (error) {
      return;
    }
  };
  /*获取活动规则*/
  _getRuleText = async () => {
    const res = await queryImageByCode({ groupCode: 'g_cffe_welfare_officer' });
    if (res && res.code == 0) {
      const data = res.data || [];
      const ruleObj = data.find((item: any) => item.materialCode === 'it_welfare_officer_rules');
      this.setState({
        ruleText: ruleObj?.title || '',
      });
      // 获取底部广告
      const filteredData = data.filter(item => {
        return item.materialCode.startsWith('it_welfare_officer_share_banner');
      });
      this.setState({
        noticeAdConfig: filteredData,
      });
    } else {
      return;
    }
  };
  /**
   * 消除点击月榜奖励
   */
  _setViewed = async (index: string, cb: Function) => {
    try {
      //id: 赛项ID
      let res = await setViewed({ invId: config.invId, rewardIndex: index });
      if (res && res.IsSuccess) {
        cb && cb();
      } else {
        this.dialog.current?.show(res.Message);
      }
    } catch (error) {
      return;
    }
  };
  /**
   * 抽奖
   */
  _invDraw = async (num: number) => {
    try {
      //测试线不支持
      await point(config.dsbcLink);
    } catch (error) {
      Logger.info({ tag: 'invite', msg: 'WAF风控打点接口失败' });
    }
    const device = await Container.getDeviceInfo();
    const securityInfo: any = await invoke('Container', 'getSecurityInfo');
    console.log(securityInfo, 'securityInfo');
    let gtoken = '';
    let deviceId = '';
    if (securityInfo && securityInfo?.gToken) {
      gtoken = securityInfo?.gToken;
    }
    let appRes = await isAppVersionGE('10.20.0');
    if (appRes && Platform.OS == 'ios') {
      try {
        const triggerSecurityInfoUploadRes: any = await invoke('Container', 'triggerSecurityInfoUpload');
      } catch (error) {}
    }
    if (device) {
      deviceId = device.euid || '';
    }
    if (!gtoken) {
      this.toast.current?.show('请稍后再试~');
    }
    try {
      let res = await invDraw({
        invId: config.invId,
        deviceId: deviceId,
        consumeCnt: num,
        gtoken: gtoken,
        drawList: this.state.drawList,
      });
      console.log(res, '抽奖结果');
      if ((res && res.IsSuccess) || res.StatusCode === -100) {
        let Data = res?.Data || null;
        if (Data && Data.useCntList) {
          this._syncDrawInfo(Data.useCntList);
        }
        return res;
      } else {
        if (res.StatusCode === -101 && !res.IsSuccess) {
          this.tipsPop.current?.show(res.Message);
          return;
        }
        this.dialog.current?.show(res.Message || ApiHasErrorMessage, {
          onOk: async () => {
            await this._getDataFromPoint();
          },
        });
        return undefined;
      }
    } catch (error) {
      return undefined;
    }
  };
  //获取转盘抽奖配置
  _getPZFromPoint = async (id: string) => {
    try {
      let res = await getPZFromPoint(id);
      if (res.result != 1) {
        return;
      }
      let arr = [];
      if (res.data && res.data.length > 0) {
        const [data1, data2, data3, data4, data5, data6, data7, data8, data9] = await Promise.all([
          this._loadImage(res.data[0].RewardSinglePic[0]),
          this._loadImage(res.data[1].RewardSinglePic[0]),
          this._loadImage(res.data[2].RewardSinglePic[0]),
          this._loadImage(res.data[3].RewardSinglePic[0]),
          this._loadImage(res.data[4].RewardSinglePic[0]),
          this._loadImage(res.data[5].RewardSinglePic[0]),
          this._loadImage(res.data[6].RewardSinglePic[0]),
          this._loadImage(res.data[7].RewardSinglePic[0]),
          this._loadImage(res.data[8].RewardSinglePic[0]),
        ]);
        arr.push(data1, data2, data3, data4, data5, data6, data7, data8, data9);
      }
      this.setState({
        rewardData: res.data ? res.data : [],
        w_hData: arr,
      });
    } catch (error) {
      return;
    }
  };
  //加载远程图片
  _loadImage = (url: string) => {
    url += `${url.includes('?') ? '&' : '?'}ver=20240202`;
    return createRemoteImageRequest(url).then(response => {
      if (response.metadata && response.status == RemoteImageRequestStatus.Ok) {
        return response.metadata;
      } else {
        this.dialog.current?.show(response.message || ApiHasErrorMessage);
        return undefined;
      }
    });
  };
  //获取剩余抽奖机会
  _getDataFromPoint = async () => {
    try {
      if (Platform.OS === 'web') {
        return;
      }
      const { hasLogin } = await Passport.getUserInfo();
      if (!hasLogin) {
        return;
      }

      let { drawConfigInfo } = this.state;
      let taskIds: any = {
        newUserTaskId: drawConfigInfo.newUserTaskId,
        normalTaskId: drawConfigInfo.normalTaskId,
        surpriseTaskId: drawConfigInfo.surpriseTaskId,
      };
      let drawList: DrawListVo[] = [];
      let times = 0;
      for (let i in taskIds) {
        let res = await getDataFromPoint(taskIds[i]);
        if (res.result != 1) {
          times += 0;
        }
        let count = res.data || res.data === 0 ? res.data : 0;
        times += count;
        let list: any = {};
        switch (i) {
          case 'newUserTaskId':
            list = {
              drawCnt: count,
              drawType: 10,
            };
            break;
          case 'normalTaskId':
            list = {
              drawCnt: count,
              drawType: 12,
            };
            break;
          case 'surpriseTaskId':
            list = {
              drawCnt: count,
              drawType: 11,
            };
            break;
        }
        drawList.push(list);
      }
      this.setState({
        drawCashTimes: `${times}`,
        drawList: drawList,
      });
    } catch (error) {
      return;
    }
  };
  /* 获取任务列表 */
  _queryTaskList = async () => {
    try {
      const { data, code } = await queryTaskList();
      if (+code === 400404) {
        //活动结束code 返回400404
        this.isEndOfActivity = true;
        this.activityEndPop.current?.show();
        return;
      }
      if (+code === 200 && data) {
        let localData = await LocalStorage.get({ name: 'EM_FRONTH5_YOUTH' });
        let dailyTaskList = [];
        if (+localData.data === 1) {
          dailyTaskList = data?.normal?.filter(a => +a.taskType !== 12 || (+a.taskType === 12 && +a.taskStatus === 2));
        } else {
          dailyTaskList = data?.normal || [];
        }
        let surprise = data?.surprise || [];
        let finished = data?.finished || [];
        let surpriseTaskList = [...surprise, ...finished];
        this.setState({
          surpriseTaskList: surpriseTaskList,
          dailyTaskList: dailyTaskList,
        });
      }
    } catch (e) {
      return;
    }
  };
  /*获取挽留弹窗是否弹出*/
  handleIsAlter = async () => {
    try {
      const { data } = await getAlterPop();
      return data;
    } catch (e) {
      return;
    }
  };
  //点击分享
  onPressShare = async () => {
    const res = await AppShare({
      trackCode: 'csj.gxyxhdy.ysj.fxqd',
      groupCode: shareAdConfig.common.code,
    });
    const { dailyTaskList } = this.state;
    if (res) {
      let data: any = dailyTaskList.find(item => item.taskId === 'ccw_9');
      await this._finishTask(data);
      this.init();
    }
    setTimeout(() => {
      if (res) {
        this.shareTipPop.current?.show();
        this.setState({
          isTaskShare: false,
        });
      }
    }, 200);
  };

  onScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { y } = event.nativeEvent.contentOffset;
    Animated.event([{ y: this.state.scrollY }])({ y });
  };
  _handScaleAnimation = () => {
    this.handAnimation = Animated.loop(
      Animated.sequence([
        Animated.timing(this.state.scaleValue, {
          toValue: { x: 10, y: 10 },
          duration: 1000, // 动画持续时间
          easing: Easing.linear, // 使用线性缓动函数
          useNativeDriver: Platform.OS !== 'web', // 使用原生驱动
        }),
        Animated.timing(this.state.scaleValue, {
          toValue: { x: 0, y: 0 },
          duration: 1000, // 动画持续时间
          easing: Easing.linear, // 使用线性缓动函数
          useNativeDriver: Platform.OS !== 'web', // 使用原生驱动
        }),
      ])
    );
    this.handAnimation.start();
  };
  _handleScaleBtnAnimation = () => {
    this.handScaleAnimation = Animated.sequence([
      Animated.timing(this.state.scaleBtn, {
        toValue: 0.95,
        duration: 60, // 动画持续时间
        easing: Easing.linear, // 使用线性缓动函数
        useNativeDriver: Platform.OS !== 'web', // 使用原生驱动
      }),
      Animated.timing(this.state.scaleBtn, {
        toValue: 1,
        duration: 60, // 动画持续时间
        easing: Easing.linear, // 使用线性缓动函数
        useNativeDriver: Platform.OS !== 'web', // 使用原生驱动
      }),
    ]);
    this.handScaleAnimation.start();
  };
  _handleScaleBtnTen = () => {
    this.handScaleTenAnimation = Animated.sequence([
      Animated.timing(this.state.scaleBtnTen, {
        toValue: 0.95,
        duration: 60, // 动画持续时间
        easing: Easing.linear, // 使用线性缓动函数
        useNativeDriver: Platform.OS !== 'web', // 使用原生驱动
      }),
      Animated.timing(this.state.scaleBtnTen, {
        toValue: 1,
        duration: 60, // 动画持续时间
        easing: Easing.linear, // 使用线性缓动函数
        useNativeDriver: Platform.OS !== 'web', // 使用原生驱动
      }),
    ]);
    this.handScaleTenAnimation.start();
  };
  ruleOnPress = () => {
    if (Platform.OS === 'web') {
      this.handleClickMask();
      return;
    }
    trackEvent('csj.gxyxhdy.hdgz.dsgz');
    this.rulePop.current?.show();
  };
  recordOnpress = async () => {
    if (Platform.OS === 'web') {
      this.handleClickMask();
      return;
    }
    const { push } = this.props.navigation;
    push('InviteProcess');
  };
  /*我要反馈按钮*/
  handleFeedBack = () => {
    if (Platform.OS === 'web') {
      this.handleClickMask();
      return;
    }
    openUrl('https://quiz-activity.eastmoney.com/qn/redirect.html?code=NyhSqA');
  };
  /* 活动规则按钮 */
  renderRuleButton = () => {
    const styles = createStyles();
    return (
      <EmTouchableOpacity
        hitSlop={{ top: rpx(10), bottom: rpx(5), left: rpx(0), right: rpx(10) }}
        style={[styles.rightBtn, styles.ruleBtn]}
        activeOpacity={0.9}
        onPress={this.ruleOnPress}
      >
        <Text style={styles.ruleText}>规则</Text>
      </EmTouchableOpacity>
    );
  };
  /*我要反馈Btn*/
  renderFeedbackButton = () => {
    const styles = createStyles();
    return (
      <EmTouchableOpacity
        hitSlop={{ top: rpx(5), bottom: rpx(10), left: rpx(0), right: rpx(10) }}
        style={[styles.rightBtn, styles.feedbackBtn]}
        activeOpacity={0.9}
        onPress={this.handleFeedBack}
      >
        <Text style={styles.ruleText}>反馈</Text>
      </EmTouchableOpacity>
    );
  };
  /*我的奖励按钮*/
  renderRewardButton = () => {
    const styles = createStyles();
    const { push } = this.props.navigation;
    return (
      <EmTouchableOpacity
        hitSlop={{ top: rpx(10), bottom: rpx(5), left: rpx(10), right: rpx(0) }}
        style={[styles.rightBtn, styles.rewardBtn]}
        activeOpacity={0.9}
        onPress={() => {
          if (Platform.OS === 'web') {
            this.handleClickMask();
            return;
          }
          push('WardRecord');
        }}
      >
        <Text style={styles.ruleText}>奖励</Text>
      </EmTouchableOpacity>
    );
  };
  /*邀请榜单按钮*/
  renderRecordButton = () => {
    const styles = createStyles();
    const { push } = this.props.navigation;
    return (
      <EmTouchableOpacity
        hitSlop={{ top: rpx(5), bottom: rpx(10), left: rpx(10), right: rpx(0) }}
        style={[styles.rightBtn, styles.recordBtn]}
        activeOpacity={0.9}
        onPress={() => {
          if (Platform.OS === 'web') {
            this.handleClickMask();
            return;
          }
          push('InviteRanking');
        }}
      >
        <View style={{ marginTop: rpx(2) }}>
          <Text style={styles.ruleText}>邀请</Text>
          <Text style={styles.ruleText}>榜单</Text>
        </View>
      </EmTouchableOpacity>
    );
  };
  stopAnimation = () => {
    if (this.slideAnimation) {
      this.slideAnimation.stop();
      this.slideAnimation = undefined;
    }
    if (this.slideAnimationV1) {
      this.slideAnimationV1.stop();
      this.slideAnimationV1 = undefined;
    }
  };
  stopHandAnimation = () => {
    if (this.handAnimation) {
      this.handAnimation.stop();
      this.handAnimation = undefined;
    }
  };
  startRotation = (angel: number, text: string, data: any) => {
    const { rotationValue, dgeValue } = this.state;
    this.setState({
      rotationValue: new Animated.Value(0),
      rotateInterpolate: rotationValue?.interpolate({
        inputRange: [0, 1],
        outputRange: [`${dgeValue}deg`, dgeValue + initDeg + angel + 'deg'],
      }),
    });
    const animationConfig = {
      toValue: 1,
      duration: 3000,
      easing: Easing.out(Easing.exp),
      useNativeDriver: Platform.OS != 'web',
    };
    this.stopAnimation();
    this.slideAnimation = Animated.timing(rotationValue, animationConfig);
    this.slideAnimation.start(({ finished }) => {
      if (finished) {
        this.setState({ dgeValue: dgeValue + initDeg + angel });
        this.resetNum++;
        if (data[0] && !data[0].rewardId) {
          this.noAwardPop.current?.show();
          return;
        }
        // this.openRedBagPop.current?.show();
      }
    });
  };
  _handleAngleNum = (data: any, k: number) => {
    const { rewardData } = this.state;
    let initIndex = 0;
    let drawIndex = 0;
    let isFindData = false;
    rewardData?.map((item, index) => {
      if (item.RewardText[0] == '随机礼品') {
        initIndex = index;
      }
      if (data[k].rewardId === item.RewardId || data[k].title === item.RewardText[0]) {
        drawIndex = index;
        isFindData = true;
      }
    });
    if (!data[k].rewardId || !isFindData) {
      drawIndex = initIndex;
    }
    return Number(drawIndex);
  };
  startRotationForTen = (data: any, k: number, res: any) => {
    const { rotationValue, dgeValue } = this.state;
    let angel = this._handleAngleNum(data, k);
    this.tenChooseName.push(data[k]);
    this.accountDrawTime++;
    this.setState({
      rotationValue: new Animated.Value(0),
      rotateInterpolate: rotationValue?.interpolate({
        inputRange: [0, 1],
        outputRange: [`${dgeValue}deg`, dgeValue + initDeg + angel + 'deg'],
      }),
    });
    const animationConfig = {
      toValue: 1,
      duration: 800,
      easing: Easing.out(Easing.exp),
      useNativeDriver: Platform.OS != 'web',
    };
    this.stopAnimation();
    this.slideAnimationV1 = Animated.timing(rotationValue, animationConfig);
    this.slideAnimationV1.start(({ finished }) => {
      if (finished) {
        this.setState({ dgeValue: dgeValue + initDeg + angel });
        this.resetNum++;
        if (this.accountDrawTime >= data.length) {
          let noAward = data.filter((a: any) => {
            return !a.rewardId;
          });
          if (res.StatusCode === -100 && res.Message) {
            this.dialog.current?.show(res.Message || ApiHasErrorMessage, {
              onOk: async () => {
                this.rotationEnabled = true;
                await this._getDataFromPoint();
              },
            });
          }
          if (noAward.length === data.length) {
            this.noAwardPop.current?.show();
            return;
          }
          this.tenDrawCashPop.current?.show(this.tenChooseName);
        } else {
          this.startRotationForTen(data, k + 1, res);
        }
      }
    });
  };

  //处理抽奖
  dealDraw = async (isTen: boolean) => {
    if (Platform.OS === 'web') {
      this.handleClickMask();
      return;
    }
    if (!this.rotationEnabled) {
      return;
    }
    this.rotationEnabled = false;
    if (this.isEndOfActivity) {
      this.activityEndPop.current?.show();
      this.rotationEnabled = true;
      return;
    }
    const { drawCashTimes, rewardData } = this.state;
    if (Number(drawCashTimes) <= 0) {
      this.noRewardPop.current?.show();
      this.rotationEnabled = true;
      return;
    }
    //是否十连抽
    if (isTen && Number(drawCashTimes) >= 10) {
      let res = await this._invDraw(10);
      let data = res?.Data?.rewardList || null;
      if (!data) {
        this.rotationEnabled = true;
        return;
      }
      this.tenChooseName = [];
      this.accountDrawTime = 0;
      this.startLotteryForTen(data, 0);
    } else if (isTen && Number(drawCashTimes) < 10) {
      this.toast.current?.show('剩余抽奖机会不满10次哦，无法十连抽，快去获取抽奖机会或者尝试单抽吧~');
      this.rotationEnabled = true;
      return;
    } else {
      let res = await this._invDraw(1);
      let data = res?.Data?.rewardList || null;
      if (!data) {
        this.rotationEnabled = true;
        return;
      }
      let num = this._handleAngleNum(data, 0);
      rewardData && rewardData.length > 0 && this.startLottery(num, data);
    }
  };
  /*完成任务增加次数*/
  _finishTask = async (data: CompWelfareTaskRes) => {
    try {
      const res = await finishTask({
        taskId: data.taskId,
      });
      if (res.success && res.code === 200) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
  /*点击去完成*/
  _handleCompleteTask = async (data: CompWelfareTaskRes) => {
    let url = '';
    if (Platform.OS == 'ios' && data.iosUrl) {
      url = data.iosUrl;
    } else if (Platform.OS == 'android' && data.androidUrl) {
      url = data.androidUrl;
    } else {
      url = data.h5Url;
    }
    if (Platform.OS === 'web') {
      this.handleClickMask();
      return;
    }
    let appRes = await isAppVersionGE('10.0.0');
    let { push } = this.props.navigation;
    let extParams = data?.extParams && JSON.parse(data.extParams);
    const { surpriseTaskList, showFlag } = this.state;
    // 获取ccw_1任务的完成状态
    const ccw_1Task = surpriseTaskList.find(item => item.taskId === 'ccw_1');
    const taskFlag = String(ccw_1Task?.taskStatus) === '2' || !ccw_1Task?.taskStatus; // 是否完成中金所报名
    switch (
      +data.taskType //任务类型
    ) {
      // 任务类型-1 分享，2 浏览，3 邀新，4 站内跳转，5 创建团队，6 团队人数奖励， 7 签到， 8 报名 9学生认证任务 10, "依赖外部状态查询任务-提现"
      case 1: //分享当前页面
        if (await AppShare({ groupCode: extParams?.shareConfigCode || '' }, data.url)) {
          if (!(await this._finishTask(data))) {
            return;
          }
          this.setState({
            isTaskShare: false,
          });
          this.shareTipPop.current?.show();
        }
        break;
      case 2:
        openUrl(url);
        await this._finishTask(data);
        break;
      case 3:
        if (await AppShare({ groupCode: extParams?.shareConfigCode || '' }, data.url)) {
          this.setState({
            isTaskShare: true,
          });
          setTimeout(() => {
            this.shareTipPop.current?.show();
          }, 1000);
        }
        break;
      case 7: //签到不需要跳转
        if (!(await this._finishTask(data))) {
          return;
        }
        this.toast.current?.show('签到成功');
        break;
      case 8:
      case 9:
        if (['ccw_7', 'ccw_8'].includes(data.taskId) && !showFlag && taskFlag) {
          // 新增逻辑，跳转答题任务，如果还未开赛则禁止跳转，提示用户等开赛后再参加答题
          this.toast.current?.show('目前比赛暂未开启，敬请期待！');
        } else {
          openUrl(url);
        }
        break;
      case 10: //提现
        push('WardRecord');
        break;
      case 4:
        // 测试添加日程功能
        this.calendarPop.current?.show({
          taskData: data, // 当前任务数据（必填，用于 _finishTask 识别任务）
          onComplete: async taskData => {
            if (taskData) {
              await this._finishTask(taskData); // 调用目标方法
              this.init(); // 可选：如果需要刷新数据
            }
          },
        });

        break;
      case 12:
        if (appRes) {
          await LocalStorage.set({
            name: 'EM_FRONTH5_YOUTH',
            data: '1',
          });
          if (!(await this._finishTask(data))) {
            return;
          }
          this.toast.current?.show('切换成功,可前往App首页查看并使用！');
        } else {
          this.toast.current?.show('切换失败,请将app升级至最新版本体验该功能哦！');
        }
    }
    if (!['ccw_7', 'ccw_8'].includes(data.taskId)) {
      this.init();
    }
  };
  /*点击已完成 对切换青春版做特殊处理*/
  _hasCompleteTask = (data: CompWelfareTaskRes) => {
    if (+data.taskType === 12 && +data.taskStatus === 2) {
      let url = '';
      if (Platform.OS == 'ios') {
        url = 'eastmoney://page/home';
      } else if (Platform.OS == 'android') {
        url = 'dfcft://home';
      }
      openUrl(url);
    }
  };
  toScroll = () => {
    if (this.state.isTaskShare) {
      return;
    }
    let height = this.jumpPosition - 100;
    this.scrollToPosition && this.scrollToPosition.scrollTo({ x: 0, y: height, animated: true });
  };
  /* 站外点击 跳转站内*/
  handleClickMask = () => {
    let ios = 'eastmoney://page/emrn?id=welfareOfficer';
    let android = 'dfcft://emrn?id=welfareOfficer';
    if (Platform.OS === 'web') {
      window.location.href =
        'https://mlink.eastmoney.com/h52n/nlink.html?type=localurl&curl=xxlout_dfcfapphdnqzy_random_0007319a&id=' +
        encodeURIComponent(ios) +
        '&a_id=' +
        encodeURIComponent(android);
    }
  };
  /**
   * 抽奖动画 -单抽
   * */
  startLottery = (num: number, data: any) => {
    // 初始快速切换
    const fastDuration = 60;
    let currentIndex = 0;
    let rewardData = this.state?.rewardData || [];
    this.setState({
      activeIndex: currentIndex,
    });
    const fastInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % rewardData.length;
      this.setState({
        activeIndex: currentIndex,
      });
    }, fastDuration);

    // 1秒后减速
    setTimeout(() => {
      clearInterval(fastInterval);

      // 减速动画
      const slowDuration = 100;
      let slowIndex = currentIndex;
      const slowInterval = setInterval(() => {
        slowIndex = (slowIndex + 1) % rewardData.length;
        this.setState({
          activeIndex: slowIndex,
        });
      }, slowDuration);

      // 5秒后停止在随机奖品
      setTimeout(() => {
        clearInterval(slowInterval);
        // 最终滚动效果
        let steps = slowIndex;
        const finalInterval = setInterval(() => {
          if (steps === num) {
            clearInterval(finalInterval);
            /*等400ms 出获奖弹窗*/
            setTimeout(() => {
              if (data[0] && !data[0].rewardId) {
                this.noAwardPop.current?.show();
                return;
              }
              let dataInfo = {
                title: data[0].title || '',
                rewardType: data[0].rewardType,
                uri: this.state.w_hData[num]?.uri || '',
              };
              this.openRedBagPop.current?.show(dataInfo);
            }, 400);
          } else {
            steps = (steps + 1) % rewardData.length;
            this.setState({
              activeIndex: steps,
            });
          }
        }, 150);
      }, 800);
    }, 800);
  };
  /**
   * 抽奖 十连抽
   * */
  startLotteryForTen = (data: any, k: number) => {
    let num = this._handleAngleNum(data, k);
    this.tenChooseName.push(data[k]);
    this.accountDrawTime++;
    let currentIndex = 0;
    this.setState({
      activeIndex: currentIndex,
    });
    const rewardData = this.state?.rewardData || [];
    let steps = 0;
    const finalInterval = setInterval(() => {
      if (steps === num && currentIndex >= rewardData.length) {
        clearInterval(finalInterval);
        if (this.accountDrawTime >= data.length) {
          let noAward = data.filter((a: any) => {
            return !a.rewardId;
          });
          if (noAward.length === data.length) {
            this.noAwardPop.current?.show();
            return;
          }
          this.tenDrawCashPop.current?.show(this.tenChooseName);
        } else {
          setTimeout(() => {
            this.startLotteryForTen(data, k + 1);
          }, 400);
        }
      } else {
        currentIndex++;
        steps = (steps + 1) % rewardData.length;
        this.setState({
          activeIndex: steps,
        });
      }
    }, 100);
  };

  /**
   * 点击抽奖按钮
   * */
  handleClickDrawBtn = () => {
    this._handleScaleBtnAnimation();
    this.dealDraw(false);
  };
  /**
   * 点击十连抽
   * */
  handleClickTenDrawBtn = () => {
    this._handleScaleBtnTen();
    this.dealDraw(true);
  };
  renderHeader = () => {
    const styles = createStyles();
    const { activeIndex, drawCashTimes, scaleBtn, scaleBtnTen, w_hData, notice } = this.state;
    return (
      <>
        <ImageBackground
          resizeMode="stretch"
          style={[styles.header_c, { marginTop: Platform.OS === 'web' ? -rpx(45) : rpx(0), marginBottom: rpx(-70) }]}
          source={require('../../images/invite/bg.png')}
        >
          <Image
            style={styles.header_c_title}
            source={require('../../images/invite/acTitle.png')}
            resizeMode={'stretch'}
          />
          {/* <View style={styles.header_title}>
            <Text style={styles.headText}>抽“第一桶金”小金条和JBL音响</Text>
          </View> */}
          <View style={styles.header_main}>
            <ImageBackground
              resizeMode="stretch"
              style={styles.header_draw_bg}
              source={require('../../images/invite/drawBg.png')}
            >
              <View style={styles.header_tip}>
                <Notice textStr={notice} />
              </View>
              <Animated.View>
                <View style={styles.header_gift}>
                  {w_hData.map((item, index) => {
                    return (
                      <View style={styles.header_gift_image}>
                        <Image style={styles.header_gift_image} source={{ uri: item?.uri }} resizeMode={'stretch'} />
                        {activeIndex === index && <View style={styles.activeGift} />}
                      </View>
                    );
                  })}
                </View>
              </Animated.View>
              <EmTouchableOpacity activeOpacity={1} style={styles.tenBtn} onPress={this.handleClickTenDrawBtn}>
                <Animated.View style={{ transform: [{ scale: scaleBtnTen }] }}>
                  <Image
                    style={styles.tenBtn_img}
                    source={require('../../images/invite/tenBtn.png')}
                    resizeMode={'stretch'}
                  />
                </Animated.View>
              </EmTouchableOpacity>
              <EmTouchableOpacity activeOpacity={1} style={styles.drawBtn} onPress={this.handleClickDrawBtn}>
                <Animated.View style={{ transform: [{ scale: scaleBtn }] }}>
                  <Image
                    style={styles.drawBtn_img}
                    source={require('../../images/invite/buttonRward.png')}
                    resizeMode={'stretch'}
                  />
                </Animated.View>
                <ImageBackground
                  style={styles.header_b_c}
                  source={require('../../images/invite/countTip.png')}
                  resizeMode={'stretch'}
                >
                  <View style={styles.headerDrawCount}>
                    <Text style={[styles.header_b_text, { fontSize: Number(drawCashTimes) >= 100 ? rpx(8) : rpx(10) }]}>
                      {'可抽'}
                    </Text>
                    <Text
                      style={[styles.header_b_text1, { fontSize: Number(drawCashTimes) >= 100 ? rpx(8) : rpx(10) }]}
                    >
                      {drawCashTimes + '次'}
                    </Text>
                  </View>
                </ImageBackground>
              </EmTouchableOpacity>
            </ImageBackground>
          </View>
          <View style={styles.header_c_c}>
            <ScrollVertical />
          </View>
        </ImageBackground>
      </>
    );
  };
  /*任务区 */
  renderTask = (data: any, index: number, dataLength: number, isSurpriseTask: boolean = false) => {
    const styles = createStyles();
    let extParams = isSurpriseTask && data?.extParams && JSON.parse(data.extParams);
    let taskExt = extParams?.taskExt || [];
    return (
      <View key={index}>
        <View style={styles.task}>
          {taskExt.length ? (
            <View>
              <View style={{ flexDirection: 'row', alignItems: 'center', width: rpx(345) }}>
                <ImageBackground
                  style={styles.taskBg}
                  source={{
                    uri: data.taskIcon,
                  }}
                  resizeMode={'contain'}
                />
                <View style={styles.task_process_c}>
                  <Text numberOfLines={2} ellipsizeMode={'tail'} style={styles.task_process_text}>
                    {data.taskName}
                  </Text>
                  {+data.taskStatus !== 2 ? (
                    <EmTouchableOpacity activeOpacity={0.8} onPress={() => this._handleCompleteTask(data)}>
                      <LinearGradient style={styles.completTask} colors={['#FF4722', '#EF8042']}>
                        <Text style={styles.toCompolet}>去完成</Text>
                      </LinearGradient>
                    </EmTouchableOpacity>
                  ) : (
                    <EmTouchableOpacity activeOpacity={0.8} onPress={() => this._hasCompleteTask(data)}>
                      <LinearGradient
                        style={[styles.completTask, styles.completTask_disable]}
                        colors={['#FF4722', '#EF8042']}
                      >
                        <Text style={styles.hasCompolet}>已完成</Text>
                      </LinearGradient>
                    </EmTouchableOpacity>
                  )}
                </View>
              </View>
              <View style={styles.processBox}>
                {taskExt.map((item: any, index: number) => {
                  return (
                    <>
                      <View key={index} style={styles.process}>
                        <Text style={styles.processTitle}>{item.name}</Text>
                        {item.rewardTimes ? (
                          <Text style={styles.processSubTitle}>抽奖次数+{item.rewardTimes}</Text>
                        ) : null}
                      </View>
                      {index !== taskExt.length - 1 && (
                        <Image
                          style={{ width: rpx(4.5), height: rpx(6) }}
                          source={require('../../images/invite/angle.png')}
                          resizeMode={'stretch'}
                        />
                      )}
                    </>
                  );
                })}
              </View>
            </View>
          ) : (
            <>
              <ImageBackground
                style={styles.taskBg}
                source={{
                  uri: data.taskIcon,
                }}
                resizeMode={'contain'}
              />
              <View style={styles.task_c}>
                <Text numberOfLines={2} ellipsizeMode={'tail'} style={styles.task_c_text}>
                  {data.taskName}
                </Text>
                <Text numberOfLines={2} ellipsizeMode={'tail'} style={styles.task_c_text1}>
                  {data.remark}
                </Text>
              </View>
              {+data.taskStatus !== 2 ? (
                <EmTouchableOpacity activeOpacity={0.8} onPress={() => this._handleCompleteTask(data)}>
                  <LinearGradient style={styles.completTask} colors={['#FF4722', '#EF8042']}>
                    {+data.taskType === 12 ? (
                      <Text style={styles.toCompolet}>去切换</Text>
                    ) : (
                      <Text style={styles.toCompolet}>去完成</Text>
                    )}
                  </LinearGradient>
                </EmTouchableOpacity>
              ) : (
                <EmTouchableOpacity activeOpacity={0.8} onPress={() => this._hasCompleteTask(data)}>
                  <LinearGradient
                    style={[styles.completTask, styles.completTask_disable]}
                    colors={['#FF4722', '#EF8042']}
                  >
                    <Text style={styles.hasCompolet}>已完成</Text>
                  </LinearGradient>
                </EmTouchableOpacity>
              )}
            </>
          )}
        </View>
        {index !== dataLength - 1 ? <View style={styles.divide} /> : null}
      </View>
    );
  };
  /*惊喜任务*/
  renderSurpriseTask = () => {
    const styles = createStyles();
    const { surpriseTaskList } = this.state;
    return surpriseTaskList.length ? (
      <View
        style={styles.surpriseBg}
        onLayout={event => {
          this.jumpPosition = event.nativeEvent.layout.y;
        }}
      >
        <LinearGradient
          style={styles.surpriseLine}
          start={{ x: 0, y: 0 }}
          end={{ x: 0, y: 0.2 }}
          colors={['#FFFFFF', '#FFFFFF']}
        >
          <ImageBackground
            style={styles.surpriseTask}
            source={require('../../images/invite/competitionTask.png')}
            resizeMode={'contain'}
          />
          <View style={styles.emptyPlace} />
          <EmTouchableOpacity style={styles.invitDetailBtn} activeOpacity={0.9} onPress={this.recordOnpress}>
            <Text style={styles.invitDetail}> {'邀请进度 >'} </Text>
          </EmTouchableOpacity>
          {surpriseTaskList.map((item, index) => {
            return this.renderTask(item, index, surpriseTaskList.length, true);
          })}
        </LinearGradient>
      </View>
    ) : null;
  };
  /*日常任务*/
  renderDailyTask = () => {
    const styles = createStyles();
    const { dailyTaskList, isWatchAllTask } = this.state;
    return (
      <View style={styles.surpriseBg}>
        <LinearGradient
          style={styles.surpriseLine}
          start={{ x: 0, y: 0 }}
          end={{ x: 0, y: 0.2 }}
          colors={['#FFFFFF', '#FFFFFF']}
        >
          <ImageBackground
            style={styles.dailyTask}
            source={require('../../images/invite/dailyTask.png')}
            resizeMode={'contain'}
          />
          <View style={styles.emptyPlace} />
          {!this.isEndOfActivity ? (
            <View style={{ alignItems: 'center' }}>
              {isWatchAllTask
                ? dailyTaskList.map((item, index) => {
                    return this.renderTask(item, index, dailyTaskList.length, false);
                  })
                : dailyTaskList.slice(0, 3).map((item, index) => {
                    return this.renderTask(item, index, 3, false);
                  })}
              {!isWatchAllTask && dailyTaskList.length > 3 ? (
                <EmTouchableOpacity
                  style={styles.watchTask}
                  activeOpacity={0.9}
                  onPress={() => {
                    this.setState({
                      isWatchAllTask: true,
                    });
                  }}
                >
                  <Text style={styles.watchAllTask}>点击查看全部任务</Text>
                  <View style={styles.arrow}>
                    <Arrow direction="down" color="#666666" size={rpx(8)} />
                  </View>
                </EmTouchableOpacity>
              ) : null}
            </View>
          ) : (
            <View style={{ alignItems: 'center', justifyContent: 'center', width: '100%', height: rpx(200) }}>
              <Text style={styles.endActivity}>活动已结束</Text>
            </View>
          )}
        </LinearGradient>
      </View>
    );
  };
  renderAdPosition = () => {
    const styles = createStyles();
    const { noticeAdConfig } = this.state;
    return noticeAdConfig && noticeAdConfig.length ? (
      <View style={styles.itemContainer}>
        <SwiperView
          loop={true}
          PaginationComponent={({ activeIndex, count }) => (
            <PaginationDot
              activeIndex={activeIndex}
              count={count}
              ActiveDotComponent={() => <View style={[styles.dot, styles.activeDot]} />}
              DotComponent={() => <View style={[styles.dot]} />}
            />
          )}
        >
          {noticeAdConfig.map((item, index) => {
            return (
              <EmTouchableOpacity
                key={index}
                onPress={() => {
                  if (Platform.OS === 'web') {
                    this.handleClickMask();
                    return;
                  }
                  let url = '';
                  if (Platform.OS == 'ios' && item.jumpIos) {
                    url = item.jumpIos;
                  } else if (Platform.OS == 'android' && item.jumpAndroid) {
                    url = item.jumpAndroid;
                  } else {
                    url = item.jumpWeb;
                  }
                  openUrl(url);
                }}
              >
                <Image style={styles.adBg} resizeMode={'contain'} source={{ uri: item.imgUrl }} />
              </EmTouchableOpacity>
            );
          })}
        </SwiperView>
      </View>
    ) : null;
  };
  render() {
    const styles = createStyles();

    const { scrollY, inviteRecordData, rewardRecordData, ruleText, isRetainPop, kickOffTime } = this.state;
    return (
      <RootSiblingContainer>
        <ScrollView
          ref={(view: any) => {
            this.scrollToPosition = view;
          }}
          style={styles.container}
          bounces={false}
          scrollEventThrottle={10}
          onScroll={this.onScroll}
        >
          <LinearGradient colors={['rgba(249, 237, 173,1)', 'rgba(251, 234, 162,1)']} style={{ alignItems: 'center' }}>
            {this.renderHeader()}
            {this.renderSurpriseTask()}
            {this.renderDailyTask()}
            {this.renderAdPosition()}
            <ImageBackground style={styles.bottomAd} source={require('../../images/invite/bottomSearch2.png')} />
            <Spacer size={rpx(50)} />
          </LinearGradient>
        </ScrollView>
        {Platform.OS !== 'web' ? (
          <AnimatedHeader
            title={'中金所杯赛事福利官'}
            scrollY={scrollY}
            titleColor="#333333"
            normalBackgroundColor="#7de1f0"
            transparentBackgroundColor="rgba(227,103,38,0)"
            goBack={async () => {
              if (isRetainPop && (await this.handleIsAlter())) {
                this.leaveRetainPop.current?.show();
                this.setState({
                  isRetainPop: false,
                });
                return;
              }
              closeContainer();
            }}
            backTheme={'black'}
            titleRight={() => {
              return (
                <ShareButton
                  onPress={() => {
                    trackEvent('csj.gxyxhdy.ysj.fx');
                    this.onPressShare();
                  }}
                />
              );
            }}
          />
        ) : null}
        {this.renderRuleButton()}
        {this.renderFeedbackButton()}
        {this.renderRewardButton()}
        {this.renderRecordButton()}
        <Dialog ref={this.dialog} />
        <Toast ref={this.toast} />
        <Loading ref={this.loading} />
        <NoRewardPop
          ref={this.noRewardPop}
          onPress={() => {
            this.noRewardPop.current?.hide();
            if (this.isEndOfActivity) {
              this.activityEndPop.current?.show();
            } else {
              this.toScroll();
            }
          }}
        />
        <RulePop ref={this.rulePop} ruleText={ruleText} />
        <CalendarPop ref={this.calendarPop} kickOffTime={kickOffTime} />
        <MonthRewardPop
          ref={this.monthRewardPop}
          onPress={(index: string) => {
            this._setViewed(index, () => {
              if (Platform.OS == 'web') {
                return;
              }
              this.monthRewardPop.current?.hide();
              let url = '';
              if (Platform.OS == 'ios') {
                url = 'eastmoney://page/emrn?id=jfzx&page=MyCoupons';
              } else {
                url = 'dfcft://emrn?id=jfzx&page=MyCoupons';
              }
              openUrl(url);
            });
          }}
          onClose={(index: string) => {
            this._setViewed(index, () => {
              this.monthRewardPop.current?.hide();
            });
          }}
        />
        <DrawCashPop
          ref={this.drawCashPop}
          onPress={async () => {
            this.drawCashPop.current?.hide();
          }}
        />
        <InviteRecordPop
          ref={this.inviteRecordPop}
          data={inviteRecordData}
          onPress={async () => {
            await this._getDataFromPoint();
            this.inviteRecordPop.current?.hide();
          }}
        />
        <RewardRecordPop
          ref={this.rewardRecordPop}
          onPress={() => {
            if (Platform.OS == 'web') {
              return;
            }
            let url = '';
            if (Platform.OS == 'ios') {
              url = 'eastmoney://page/emrn?id=jfzx&page=MyCoupons';
            } else {
              url = 'dfcft://emrn?id=jfzx&page=MyCoupons';
            }
            openUrl(url);
          }}
          data={rewardRecordData}
        />
        <OpenRedBagPop
          ref={this.openRedBagPop}
          onPress={async () => {
            await this._getDataFromPoint();
            this.rotationEnabled = true;
          }}
        />
        <TenDrawCashPop
          ref={this.tenDrawCashPop}
          onCancel={async () => {
            await this._getDataFromPoint();
            this.rotationEnabled = true;
          }}
        />
        <ActivityEndPop
          ref={this.activityEndPop}
          onPress={async () => {
            this.activityEndPop.current?.hide();
            await this._getMonthRwdList();
          }}
        />
        <PageVisibilityWatch tag={'Invite'} onShow={() => this.onAppear()} />
        <SurpriseTaskPop
          ref={this.surpriseTaskPop}
          onPress={async () => {
            await this._addAwardCount();
            this.init();
          }}
        />
        <LeaveRetainPop
          ref={this.leaveRetainPop}
          onPress={() => {
            this.toScroll();
          }}
        />
        <NoAwardPop
          ref={this.noAwardPop}
          onPress={async () => {
            await this._getDataFromPoint();
            this.rotationEnabled = true;
          }}
        />
        <ShareTipPop
          ref={this.shareTipPop}
          isTaskShare={this.state.isTaskShare}
          onPress={() => {
            this.setState({
              isTaskShare: false,
            });
            this.toScroll();
          }}
        />
        <CountLimitPop ref={this.countLimitPop} promWay={this.state.promWay} level={this.state.level} />
        <TipsPop
          ref={this.tipsPop}
          onPress={() => {
            this._getDataFromPoint();
          }}
        />
        <TrackPage pageName={'1250621324023'} />
      </RootSiblingContainer>
    );
  }
}

function createStyles() {
  return StyleSheet.create({
    nodata_img: {
      width: rpx(120),
      height: rpx(120),
    },
    nodata_c: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    nodata_text: {
      fontSize: rpx(15),
      color: '#999999',
    },
    header_c: {
      width: rpx(390),
      height: rpx(670),
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
    },
    header_c_title: {
      marginTop: rpx(10),
      marginBottom: rpx(10),
      width: rpx(292),
      height: rpx(56),
    },
    header_title: {
      marginTop: rpx(2),
    },
    headText: {
      fontSize: rpx(14),
      color: '#333333',
      fontWeight: 'bold',
    },
    header_main: {
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      // marginTop: rpx(14),
    },
    header_draw_bg: {
      width: rpx(336),
      height: rpx(436.5),
      position: 'relative',
    },
    header_item1: {
      alignItems: 'center',
      width: rpx(297),
      height: rpx(297 / 2),
      justifyContent: 'center',
      position: 'absolute',
      top: rpx(0),
      left: -rpx(48),
      transform: [{ rotateZ: '-30deg' }],
    },
    header_item2: {
      alignItems: 'center',
      width: rpx(297),
      height: rpx(297 / 2),
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      left: rpx(40),
      transform: [{ rotateZ: '30deg' }],
    },
    header_item3: {
      alignItems: 'center',
      width: rpx(297),
      height: rpx(297 / 2),
      justifyContent: 'center',
      position: 'absolute',
      top: rpx(75),
      left: rpx(90),
      transform: [{ rotateZ: '90deg' }],
    },
    header_item4: {
      alignItems: 'center',
      width: rpx(297),
      height: rpx(297 / 2),
      justifyContent: 'center',
      position: 'absolute',
      bottom: 0,
      left: rpx(40),
      transform: [{ rotateZ: '150deg' }],
    },
    header_item5: {
      alignItems: 'center',
      width: rpx(297),
      height: rpx(297 / 2),
      justifyContent: 'center',
      position: 'absolute',
      bottom: 0,
      left: -rpx(42),
      transform: [{ rotateZ: '210deg' }],
    },
    header_item6: {
      alignItems: 'center',
      width: rpx(297),
      height: rpx(297 / 2),
      justifyContent: 'center',
      position: 'absolute',
      bottom: rpx(73),
      left: -rpx(90),
      transform: [{ rotateZ: '270deg' }],
      //backgroundColor:'rgba(3,3,3,0.2)'
    },
    header_item_text: {
      fontSize: rpx(12),
      color: '#333333',
    },
    header_item_img: {
      width: rpx(37.3),
      justifyContent: 'center',
    },
    drawButton_Img: {
      width: rpx(73),
      height: rpx(87),
      marginRight: rpx(3),
    },
    header_b_c: {
      position: 'absolute',
      right: rpx(-10),
      top: rpx(-6),
      width: rpx(55),
      height: rpx(18),
    },
    headerDrawCount: {
      width: rpx(55),
      height: rpx(18),
      flexDirection: 'row',
      alignItems: 'center',
      textAlign: 'center',

      justifyContent: 'center',
    },
    header_b_text: {
      fontSize: rpx(10),
      color: '#FFFFFF',
      fontWeight: 'bold',
      lineHeight: rpx(18),
    },
    header_b_text1: {
      fontSize: rpx(10),
      color: '#FFFFFF',
      fontWeight: 'bold',
      lineHeight: rpx(18),
    },
    header_b_r: {
      alignItems: 'center',
      position: 'absolute',
      bottom: rpx(25),
      right: -rpx(55),
    },
    header_tip: {
      position: 'absolute',
      top: isIPad ? rpx(16) : rpx(14),
      left: rpx(58),
      width: rpx(218),
    },
    header_gift: {
      marginTop: rpx(55),
      marginLeft: rpx(35),
      width: rpx(270),
      height: rpx(250),
      justifyContent: 'space-around',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    header_gift_image: {
      position: 'relative',
      marginTop: rpx(6),
      width: rpx(80),
      height: rpx(78),
    },
    activeGift: {
      position: 'absolute',
      top: rpx(5),
      left: 0,
      borderRadius: rpx(10),
      backgroundColor: 'rgba(255,255,255,0.7)',
      width: rpx(80),
      height: rpx(75),
    },
    tenBtn: {
      position: 'absolute',
      bottom: rpx(40),
      left: rpx(30),
    },
    tenBtn_img: {
      width: rpx(61),
      height: rpx(48),
    },
    drawBtn: {
      position: 'absolute',
      bottom: rpx(40),
      left: rpx(100),
    },
    drawBtn_img: {
      width: rpx(156),
      height: rpx(54.5),
    },
    header_c_c: {
      position: 'absolute',
      bottom: rpx(175),
      left: '5%',
    },
    header_b_r_text: {
      fontSize: rpx(11),
      color: '#4680E5',
      fontWeight: 'bold',
      marginBottom: rpx(4),
    },
    sec3_b_c: {
      flexDirection: 'row',
      alignItems: 'center',
      width: rpx(300),
      height: rpx(50),
    },
    sec3_rank_text4: {
      color: '#333333',
      fontSize: rpx(12),
      fontWeight: 'bold',
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank_text3: {
      color: '#333333',
      fontSize: rpx(15),
      fontWeight: 'bold',
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank_text3_1: {
      color: '#FF341E',
    },
    sec3_rank_text2: {
      color: '#333333',
      fontSize: rpx(12),
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank_text1: {
      color: '#333333',
      fontSize: rpx(18),
      fontWeight: 'bold',
      flex: 1.5,
      textAlign: 'center',
    },
    first_img: {
      width: rpx(26),
      height: rpx(21),
    },
    sec3_item: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: rpx(5.5),
      backgroundColor: 'rgba(215,226,250,1)',
      borderRadius: rpx(6),
      width: rpx(300),
      height: rpx(50),
    },
    sec3_rank2: {
      color: '#666666',
      fontSize: rpx(12),
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank1: {
      color: '#666666',
      fontSize: rpx(12),
      flex: 1.5,
      textAlign: 'center',
    },
    sec3_rankTitle: {
      flexDirection: 'row',
      width: rpx(300),
    },
    sec3_text2: {
      fontSize: rpx(15),
      color: '#566CFD',
    },
    sec3_text1: {
      fontSize: rpx(15),
      color: '#FFFFFF',
    },
    sec3_btn: {
      width: rpx(90),
      height: rpx(35),
      backgroundColor: 'rgba(234,241,252,1)',
      borderRadius: rpx(20),
      alignItems: 'center',
      justifyContent: 'center',
    },
    sec3_tit_main_c: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      width: '100%',
    },
    sec3_tit_main: {
      alignItems: 'center',
    },
    sec3Bg_img: {
      width: '100%',
      height: rpx(770),
      alignItems: 'center',
      justifyContent: 'center',
    },
    sec3_main: {
      width: '100%',
      paddingHorizontal: rpx(15),
      //alignItems:'center'
    },
    sec2_text3: {
      fontSize: rpx(18),
      color: '#FFFFFF',
    },
    sec2_btn: {
      alignItems: 'center',
      width: rpx(216),
      height: rpx(45),
      justifyContent: 'center',
      borderRadius: rpx(22.5),
    },
    sec2_text2: {
      fontSize: rpx(12),
      color: '#6570C2',
      fontWeight: 'bold',
    },
    sec2_text1: {
      fontSize: rpx(24),
      color: '#FF341E',
      fontWeight: 'bold',
    },
    sec2_main: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      width: '100%',
    },
    sec2_text: {
      fontSize: rpx(11),
      color: '#6570C2',
      fontWeight: 'bold',
      marginRight: rpx(3),
    },
    sec2_jljl: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    question_img: {
      width: rpx(15),
      height: rpx(15),
      marginLeft: rpx(90),
    },
    title2_img: {
      width: rpx(256),
      height: rpx(51),
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: -rpx(15),
    },
    sec2_c_c: {
      alignItems: 'center',
    },
    sec2Bg_img: {
      width: '100%',
      height: rpx(220.5),
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    sec2_c: {
      width: '100%',
      paddingHorizontal: rpx(15),
    },
    container: {
      width: '100%',
      flex: 1,
    },
    sec1_main: {
      width: '100%',
      paddingHorizontal: rpx(15),
    },
    sec1_text: {
      fontSize: rpx(12),
      color: '#6570c2',
      fontWeight: '600',
    },
    sec1BgImg: {
      width: '100%',
      height: rpx(274.5),
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    title1Img: {
      width: rpx(256),
      height: rpx(51),
      position: 'absolute',
      top: -rpx(15),
    },
    sec1_c: { flexDirection: 'row', justifyContent: 'center', width: '100%' },
    step1Img: {
      width: rpx(71),
      height: rpx(71),
    },
    sec_invite: {
      alignItems: 'center',
      width: rpx(216),
      height: rpx(45),
      justifyContent: 'center',
      borderRadius: rpx(22.5),
    },
    sec1_text1: {
      fontSize: rpx(18),
      color: '#FFFFFF',
    },
    sec1_texe2: {
      fontSize: rpx(11),
      color: '#6570C2',
    },
    sec1_text3: {
      fontSize: rpx(11),
      color: 'rgba(255,94,14,1)',
      fontWeight: 'bold',
    },
    leftBtn: {
      position: 'absolute',
      left: rpx(0),
      width: rpx(23),
      height: rpx(58),
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#648dff',
      borderTopRightRadius: rpx(7.33),
      borderBottomRightRadius: rpx(7.33),
    },
    ruleBtn: {
      top: Platform.select({
        web: rpx(90),
        android: rpx(90),
        ios: rpx(90),
      }),
    },
    /*反馈*/
    feedbackBtn: {
      top: Platform.select({
        web: rpx(130),
        android: rpx(130),
        ios: rpx(130),
      }),
    },
    rightBtn: {
      position: 'absolute',
      right: rpx(12),
      width: rpx(32),
      height: rpx(32),
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 136, 199,0.5)',
      borderRadius: rpx(16),
    },
    /* 我的奖励 */
    rewardBtn: {
      top: Platform.select({
        web: rpx(170),
        android: rpx(170),
        ios: rpx(170),
      }),
    },
    /* 邀请榜单 */
    recordBtn: {
      top: Platform.select({
        web: rpx(210),
        android: rpx(210),
        ios: rpx(210),
      }),
    },
    ruleText: {
      fontSize: rpx(10),
      color: '#fff',
      lineHeight: rpx(12),
      textAlign: 'center',
    },
    button_reward_Img: {
      width: rpx(232),
      height: rpx(74),
      alignItems: 'center',
      justifyContent: 'center',
    },
    button_reward_text: {
      position: 'absolute',
      fontSize: rpx(26),
      color: '#fff',
      fontWeight: 'bold',
      left: rpx(65),
      top: rpx(21),
    },
    count_tip: {
      position: 'absolute',
      width: rpx(90),
      height: rpx(30),
      right: rpx(0),
      top: rpx(-10),
    },
    hand_tip: {
      position: 'absolute',
      width: rpx(46),
      height: rpx(40),
      right: rpx(-9),
      top: rpx(-40),
    },
    notice: {
      marginTop: rpx(23),
      height: rpx(30),
      width: rpx(375),
      alignItems: 'center',
      justifyContent: 'center',
    },
    noticeText: {
      fontSize: rpx(12),
      color: '#5748E6',
    },
    titleTip: {
      marginTop: rpx(20),
      width: rpx(221),
      height: rpx(45),
    },
    surpriseBg: {
      marginTop: rpx(15),
      width: rpx(345),
      zIndex: 1,
    },
    surpriseLine: {
      width: rpx(345),
      backgroundColor: '#fff',
      borderRadius: rpx(12),
      alignItems: 'center',
      position: 'relative',
      paddingBottom: rpx(15),
    },
    surpriseTask: {
      position: 'absolute',
      left: rpx(15),

      width: rpx(194),
      height: rpx(44),
    },
    dailyTask: {
      position: 'absolute',
      left: rpx(15),
      top: rpx(10),
      width: rpx(85),
      height: rpx(31),
    },
    emptyPlace: {
      width: rpx(194),
      height: rpx(44),
      marginBottom: rpx(15),
    },
    invitDetailBtn: {
      position: 'absolute',
      right: rpx(10),
      top: rpx(15),
    },
    invitDetail: {
      color: '#666666',
      fontSize: rpx(12),
    },
    task: {
      marginLeft: rpx(18),
      width: rpx(345),
      minHeight: rpx(44),
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    taskBg: {
      width: rpx(34),
      height: rpx(34),
    },
    task_c: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginLeft: rpx(8),
      flex: 1,
    },
    task_c_text: {
      fontSize: rpx(14),
      color: '#333333',
      fontWeight: 'bold',
      marginRight: rpx(10),
    },
    task_process_text: {
      fontSize: rpx(14),
      color: '#333333',
      fontWeight: 'bold',
      width: rpx(220),
    },
    task_process_c: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginLeft: rpx(8),
    },
    task_c_text1: {
      marginTop: rpx(3),
      fontSize: rpx(10),
      color: '#666666',
      marginRight: rpx(10),
    },
    processBox: {
      marginLeft: rpx(2),
      marginTop: rpx(10),
      width: rpx(320),
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      paddingLeft: rpx(10),
      paddingRight: rpx(10),
    },
    process: {
      alignItems: 'center',
      width: rpx(120),
      height: rpx(45),
      borderRadius: rpx(5),
      backgroundColor: '#FEEAEF',
    },
    processTitle: {
      marginTop: rpx(7),
      color: '#FE3766',
      fontSize: rpx(12),
    },
    processSubTitle: {
      marginTop: rpx(3),
      fontSize: rpx(10),
      color: '#333333',
    },
    completTask: {
      width: rpx(56),
      height: rpx(26),
      borderRadius: rpx(16),
      marginRight: rpx(20),
    },
    toCompolet: {
      fontSize: rpx(12),
      color: '#fff',
      fontWeight: 'bold',
      lineHeight: rpx(26),
      textAlign: 'center',
    },
    hasCompolet: {
      fontSize: rpx(12),
      color: '#fff',
      fontWeight: 'bold',
      lineHeight: rpx(26),
      textAlign: 'center',
      opacity: 0.9,
    },
    completTask_disable: {
      opacity: 0.6,
    },
    divide: {
      height: rpx(1),
      backgroundColor: '#989898',
      marginTop: rpx(9),
      marginBottom: rpx(9),
      width: rpx(317),
      opacity: 0.1,
      alignSelf: 'center',
    },
    watchAllTask: {
      fontSize: rpx(12),
      color: '#666666',
      marginTop: rpx(18),
      marginBottom: rpx(5),
      marginRight: rpx(3),
    },
    watchTask: {
      width: rpx(120),
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    arrow: {
      marginTop: rpx(8),
      marginLeft: rpx(3),
    },
    dot: {
      width: rpx(7),
      height: rpx(7),
      borderRadius: rpx(3),
      marginRight: rpx(5),
      backgroundColor: '#cccccc',
      opacity: 0.8,
    },
    activeDot: {
      backgroundColor: '#ffffff',
      opacity: 0.8,
    },
    adBg: {
      width: rpx(340),
      height: rpx(80),
      marginLeft: rpx(4),
      marginRight: rpx(4),
      borderRadius: rpx(10),
    },
    itemContainer: {
      marginTop: rpx(16),
      width: rpx(345),
      height: rpx(80),
    },
    bottomAd: {
      marginTop: rpx(30),
      width: rpx(278),
      height: rpx(40),
    },
    screenText: {
      fontSize: rpx(12),
      color: '#FFFFFF',
      paddingHorizontal: rpx(4),
    },
    scrollItem: {
      justifyContent: 'center',
      height: rpx(20),
      lineHeight: rpx(20),
      alignItems: 'center',
      marginRight: rpx(10),
    },
    noTask: {
      height: rpx(200),
    },
    endActivity: {
      fontSize: rpx(20),
    },
    pageMask: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0)',
      zIndex: 9999,
    },
  });
}
